export default {
  custom_additive: {
    placeholder: 'Tilføj brugerdefineret valg',
  },
  buttons: {
    add: 'Tilføj',
  },
};
